import { otmsHttp } from '@/utils/http/index.js'

/**
 * 仓库位置-查询行政区域
 * @param {object} data 查询参数
 * https://yapi.ops.yunlizhi.cn/project/130/interface/api/693
 */
export function fetchRegion(data, params) {
	return otmsHttp.request({
		url: '/city_area/list',
		method: 'post',
		data,
		params,
	})
}

/**
 * 获取仓合同
 *  https://yapi.ops.yunlizhi.cn/project/202/interface/api/9838
 */
 export function getWareHouseContract(data) {
  return otmsHttp.request({
      url: '/bfs_pricing_rule/contract/all_type/list',
      method: 'post',
      data,
  })
}

/**
 * 新增委托找仓
 * @param {object} data 查询参数
 * https://yapi.ops.yunlizhi.cn/project/295/interface/api/16071
 */
 export function programme(data) {
	return otmsHttp.request({
		url: '/customer_store_search/create',
		method: 'post',
		data,
	})
}
